/* ============================================================
   Imperial TCG — global.js
   Cart drawer + AJAX cart, free-gift/free-shipping bar, search,
   theme toggle, qty steppers. Accessible (focus trap, Esc, aria-live).
   Reads config from window.themeConfig (set in theme.liquid / settings).
   ============================================================ */
(function () {
  'use strict';
  var cfg = window.themeConfig || {};
  var money = function (cents) {
    return (cfg.moneyFormat || '${{amount}}').replace('{{amount}}', (cents / 100).toFixed(2));
  };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var live = function (msg) { var el = $('#cart-live-region'); if (el) el.textContent = msg; };

  /* ---------- flash toast ---------- */
  var flashTimer;
  function flash(msg) {
    var f = $('#flash'); if (!f) { f = document.createElement('div'); f.id = 'flash'; f.className = 'flash'; document.body.appendChild(f); }
    f.textContent = msg; f.classList.add('is-show'); clearTimeout(flashTimer);
    flashTimer = setTimeout(function () { f.classList.remove('is-show'); }, 1800);
  }

  /* ---------- focus trap for overlays ---------- */
  var lastFocused = null;
  function trap(container) {
    var f = $$('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])', container);
    if (!f.length) return function () {};
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    return function () { container.removeEventListener('keydown', onKey); };
  }

  /* ==========================================================
     CART
     ========================================================== */
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function addItem(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); });
  }
  function changeItem(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  /* ----- free gift auto add/remove ----- */
  function syncGift(cart) {
    if (!cfg.freeGiftEnabled || !cfg.freeGiftVariantId) return Promise.resolve(cart);
    var threshold = (cfg.freeGiftThreshold || 0) * 100;
    var giftLine = cart.items.filter(function (i) { return i.variant_id === cfg.freeGiftVariantId; })[0];
    // subtotal excluding the gift line
    var paid = cart.items.reduce(function (s, i) { return s + (i.variant_id === cfg.freeGiftVariantId ? 0 : i.line_price); }, 0);
    if (paid >= threshold && !giftLine) {
      return addItem(cfg.freeGiftVariantId, 1).then(getCart).then(function (c) { flash(cfg.msgGiftUnlocked || 'Free gift unlocked!'); return c; });
    }
    if (paid < threshold && giftLine) {
      return changeItem(giftLine.key, 0).then(getCart);
    }
    return Promise.resolve(cart);
  }

  /* ----- render drawer ----- */
  function paidSubtotal(cart) {
    return cart.items.reduce(function (s, i) { return s + (i.variant_id === cfg.freeGiftVariantId ? 0 : i.line_price); }, 0);
  }
  function renderCart(cart) {
    var count = cart.items.reduce(function (s, i) { return s + (i.variant_id === cfg.freeGiftVariantId ? 0 : i.quantity); }, 0);
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0 && el.hasAttribute('data-hide-empty'); });
    var items = $('[data-cart-items]');
    if (items) {
      if (!cart.items.length) { items.innerHTML = '<p class="drawer__empty">' + (cfg.emptyText || 'Your cart is empty.') + '</p>'; }
      else items.innerHTML = cart.items.map(function (i) {
        var gift = i.variant_id === cfg.freeGiftVariantId;
        var img = i.image ? '<img src="' + i.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_112x112$1') + '" alt="" width="56" height="56">' : '';
        return '<div class="line-item' + (gift ? ' line-item--gift' : '') + '">' + img +
          '<div class="line-item__info"><h3 class="card__title">' + i.product_title + '</h3>' +
          (gift
            ? '<span class="gift-badge">' + (cfg.giftLabel || 'Free gift') + '</span><div class="price">' + money(0) + '</div>'
            : '<div class="price">' + money(i.final_price) + '</div>' +
              '<div class="stepper" data-line="' + i.key + '">' +
              '<button type="button" data-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
              '<input type="text" value="' + i.quantity + '" inputmode="numeric" aria-label="Quantity" readonly>' +
              '<button type="button" data-qty="1" aria-label="Increase quantity">+</button></div>') +
          '</div></div>';
      }).join('');
    }
    var sub = $('[data-cart-subtotal]'); if (sub) sub.textContent = money(cart.total_price);
    renderShipBar(paidSubtotal(cart));
    live(cfg.itemsInCart ? cfg.itemsInCart.replace('{{count}}', count) : count + ' items in cart');
  }

  /* ----- free shipping / gift progress bar ----- */
  function renderShipBar(paid) {
    var bars = $$('[data-ship-bar]'); if (!bars.length) return;
    var tiers = [];
    if (cfg.freeGiftEnabled) tiers.push({ amount: (cfg.freeGiftThreshold || 0) * 100, label: cfg.giftTierLabel || 'Free gift', em: '🎁' });
    if (cfg.freeShippingEnabled) tiers.push({ amount: (cfg.freeShippingThreshold || 0) * 100, label: cfg.shipTierLabel || 'Free shipping', em: '🚚' });
    tiers.sort(function (a, b) { return a.amount - b.amount; });
    if (!tiers.length) { bars.forEach(function (b) { b.hidden = true; }); return; }
    var barMax = tiers[tiers.length - 1].amount;
    var next = tiers.filter(function (t) { return paid < t.amount; })[0];

    bars.forEach(function (bar) {
      bar.hidden = false;
      var fill = $('.track__fill', bar); if (fill) { fill.style.width = Math.min(100, paid / barMax * 100) + '%'; fill.classList.toggle('is-complete', paid >= barMax); }
      var ticks = $$('.tick', bar);
      tiers.forEach(function (t, idx) { if (ticks[idx]) { ticks[idx].classList.toggle('is-hit', paid >= t.amount); var lbl = $('.tick__label', ticks[idx]); if (lbl) lbl.textContent = t.label + ' · ' + money(t.amount); } });
      var em = $('.ship-bar__em', bar), msg = $('.ship-bar__msg-text', bar), subl = $('.ship-bar__sub', bar);
      if (!next) { if (em) em.textContent = '🎉'; if (msg) msg.textContent = cfg.msgAllUnlocked || "You've unlocked every reward!"; if (subl) subl.textContent = cfg.msgAllUnlockedSub || 'Applied at checkout.'; }
      else {
        if (em) em.textContent = next.em;
        if (msg) msg.textContent = (cfg.msgAway || 'Add {{amount}} more for {{reward}}').replace('{{amount}}', money(next.amount - paid)).replace('{{reward}}', next.label.toLowerCase());
        var later = tiers.filter(function (t) { return t.amount > next.amount && paid < t.amount; })[0];
        if (subl) subl.textContent = later ? (cfg.msgThen || 'Then {{amount}} more unlocks {{reward}}').replace('{{amount}}', money(later.amount - paid)).replace('{{reward}}', later.label.toLowerCase()) : '';
      }
      var rem = $('.cart-reminder', bar);
      if (rem) { var some = paid >= tiers[0].amount; if (some && next) { rem.hidden = false; var t = $('.cart-reminder__text', rem); if (t) t.textContent = (cfg.msgReminder || "You're {{amount}} away from {{reward}} — add a little more!").replace('{{amount}}', money(next.amount - paid)).replace('{{reward}}', next.label.toLowerCase()); } else rem.hidden = true; }
    });
  }

  function refresh() { return getCart().then(syncGift).then(function (c) { return getCart(); }).then(function (c) { renderCart(c); return c; }); }

  /* ----- drawer open/close ----- */
  var releaseTrap = function () {};
  function openDrawer() {
    var d = $('#CartDrawer'), o = $('#CartOverlay'); if (!d) return;
    lastFocused = document.activeElement;
    o && o.classList.add('is-open'); d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    releaseTrap = trap(d); var c = $('.drawer__close', d); c && c.focus();
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var d = $('#CartDrawer'), o = $('#CartOverlay'); if (!d) return;
    o && o.classList.remove('is-open'); d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    releaseTrap(); document.body.style.overflow = ''; lastFocused && lastFocused.focus();
  }

  /* ==========================================================
     MENU drawer (mobile nav) — mirrors the cart drawer
     ========================================================== */
  var releaseMenuTrap = function () {};
  function setBurgerExpanded(open) {
    $$('[data-action="open-menu"]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  }
  function openMenu() {
    var d = $('#MenuDrawer'), o = $('#MenuOverlay'); if (!d) return;
    lastFocused = document.activeElement;
    o && o.classList.add('is-open'); d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    setBurgerExpanded(true);
    releaseMenuTrap = trap(d); var c = $('.menu-drawer__close', d); c && c.focus();
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    var d = $('#MenuDrawer'), o = $('#MenuOverlay'); if (!d) return;
    o && o.classList.remove('is-open'); d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    setBurgerExpanded(false);
    releaseMenuTrap(); document.body.style.overflow = ''; lastFocused && lastFocused.focus();
  }

  /* ==========================================================
     SEARCH modal
     ========================================================== */
  var releaseSearchTrap = function () {};
  function openSearch() {
    var m = $('#SearchModal'), o = $('#SearchOverlay'); if (!m) return;
    lastFocused = document.activeElement;
    o && o.classList.add('is-open'); m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false');
    releaseSearchTrap = trap(m); var i = $('input[type="search"]', m); if (i) { i.value = ''; setTimeout(function () { i.focus(); }, 60); }
  }
  function closeSearch() {
    var m = $('#SearchModal'), o = $('#SearchOverlay'); if (!m) return;
    o && o.classList.remove('is-open'); m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true');
    releaseSearchTrap(); lastFocused && lastFocused.focus();
  }
  var searchTimer;
  function predictiveSearch(q, target) {
    if (!q) { target.innerHTML = ''; return; }
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,article&resources[limit]=8';
      fetch(url).then(function (r) { return r.json(); }).then(function (data) {
        var p = (data.resources.results.products || []);
        if (!p.length) { target.innerHTML = '<p class="sempty">' + (cfg.noResults || 'No matches — try a set, card, or grade.') + '</p>'; return; }
        target.innerHTML = '<p class="search-results__grp mono">' + (cfg.productsLabel || 'Products') + ' · ' + p.length + '</p>' +
          p.map(function (x) {
            var img = x.image ? '<img src="' + x.image + '" alt="" width="42" height="42">' : '';
            return '<a class="search-result" href="' + x.url + '">' + img + '<span class="search-result__title">' + x.title + '</span><span class="price">' + (x.price ? money(parseInt(x.price, 10)) : '') + '</span></a>';
          }).join('');
      });
    }, 200);
  }

  /* ==========================================================
     BACK-IN-STOCK modal — mirrors the cart drawer (trap, Esc, aria)
     ========================================================== */
  var releaseNotifyTrap = function () {};
  var notifyLastFocused = null;
  var activeNotify = null;
  function openNotify(id) {
    var m = id && document.getElementById(id); if (!m) return;
    var o = document.getElementById(id + '-overlay');
    notifyLastFocused = document.activeElement;
    o && o.classList.add('is-open'); m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false');
    activeNotify = m;
    releaseNotifyTrap = trap(m);
    var i = m.querySelector('input[type="email"]'); if (i) setTimeout(function () { i.focus(); }, 50);
    document.body.style.overflow = 'hidden';
  }
  function closeNotify() {
    if (!activeNotify) return;
    var m = activeNotify, o = document.getElementById(m.id + '-overlay');
    o && o.classList.remove('is-open'); m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true');
    releaseNotifyTrap(); activeNotify = null;
    document.body.style.overflow = '';
    notifyLastFocused && notifyLastFocused.focus();
  }

  /* ==========================================================
     THEME toggle
     ========================================================== */
  function toggleTheme() {
    var r = document.documentElement;
    var cur = r.getAttribute('data-theme');
    if (cur === 'auto' || !cur) cur = matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    var next = cur === 'dark' ? 'light' : 'dark';
    r.setAttribute('data-theme', next);
    try { localStorage.setItem('theme', next); } catch (e) {}
  }
  (function initTheme() { try { var t = localStorage.getItem('theme'); if (t) document.documentElement.setAttribute('data-theme', t); } catch (e) {} })();

  /* ==========================================================
     Delegated events
     ========================================================== */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-action]');
    if (t) {
      var a = t.getAttribute('data-action');
      if (a === 'open-cart') { e.preventDefault(); openDrawer(); }
      if (a === 'close-cart') { e.preventDefault(); closeDrawer(); }
      if (a === 'open-search') { e.preventDefault(); openSearch(); }
      if (a === 'close-search') { e.preventDefault(); closeSearch(); }
      if (a === 'open-menu') { e.preventDefault(); openMenu(); }
      if (a === 'close-menu') { e.preventDefault(); closeMenu(); }
      if (a === 'toggle-theme') { e.preventDefault(); toggleTheme(); }
      if (a === 'open-notify') { e.preventDefault(); openNotify(t.getAttribute('data-notify-target')); }
      if (a === 'close-notify') { e.preventDefault(); closeNotify(); }
    }
    // add to cart (product forms & cards)
    var add = e.target.closest('[data-add-to-cart]');
    if (add) {
      e.preventDefault();
      var id = parseInt(add.getAttribute('data-variant-id') || (add.form && add.form.querySelector('[name="id"]') && add.form.querySelector('[name="id"]').value), 10);
      var qtyEl = add.form && add.form.querySelector('[name="quantity"]');
      // data-quantity (set by the bundle selector) wins — needed for buttons with no form (sticky bar)
      var qtyAttr = add.getAttribute('data-quantity');
      var qty = qtyAttr ? parseInt(qtyAttr, 10) : (qtyEl ? parseInt(qtyEl.value, 10) : 1);
      if (!id) return;
      add.setAttribute('disabled', 'disabled');
      addItem(id, qty).then(function () { return refresh(); }).then(function () { openDrawer(); flash(cfg.addedText || 'Added to cart'); })
        .catch(function () { flash(cfg.errorText || 'Could not add — try again.'); })
        .then(function () { add.removeAttribute('disabled'); });
    }
    // qty steppers in drawer
    var q = e.target.closest('.stepper [data-qty]');
    if (q) {
      var wrap = q.closest('[data-line]'); if (!wrap) return;
      var key = wrap.getAttribute('data-line');
      var input = wrap.querySelector('input');
      var nv = Math.max(0, parseInt(input.value, 10) + parseInt(q.getAttribute('data-qty'), 10));
      changeItem(key, nv).then(function () { return refresh(); });
    }
    // predictive search chips
    var chip = e.target.closest('[data-search-term]');
    if (chip) { var input2 = $('#SearchModal input[type="search"]'); if (input2) { input2.value = chip.getAttribute('data-search-term'); predictiveSearch(input2.value, $('#SearchModal .search-results')); input2.focus(); } }
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('#SearchModal input[type="search"]')) predictiveSearch(e.target.value, $('#SearchModal .search-results'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeSearch(); closeMenu(); closeNotify(); }
    if ((e.key === 'k' && (e.metaKey || e.ctrlKey)) || (e.key === '/' && document.activeElement.tagName !== 'INPUT' && document.activeElement.tagName !== 'TEXTAREA')) { e.preventDefault(); openSearch(); }
  });

  // AJAX add-to-cart for standard product forms
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"]');
    if (!form || form.hasAttribute('data-no-ajax')) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    var qtyEl = form.querySelector('[name="quantity"]');
    addItem(parseInt(id, 10), qtyEl ? parseInt(qtyEl.value, 10) : 1)
      .then(function () { return refresh(); }).then(function () { openDrawer(); flash(cfg.addedText || 'Added to cart'); })
      .catch(function () { flash(cfg.errorText || 'Could not add — try again.'); });
  });

  // PDP: pill / thumbnail variant pickers -> update the hidden id input and fire change
  document.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-variant-opt]');
    if (!opt) return;
    var field = opt.closest('.field');
    var input = field && field.querySelector('[data-variant-input]');
    if (!input) return;
    input.value = opt.getAttribute('data-variant-opt');
    var picker = opt.closest('[data-variant-picker]');
    if (picker) {
      var opts = picker.querySelectorAll('[data-variant-opt]');
      for (var i = 0; i < opts.length; i++) opts[i].setAttribute('aria-checked', opts[i] === opt ? 'true' : 'false');
    }
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // PDP: keep the Add-to-cart label/price in sync with the chosen variant
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.pb-buy [name="id"]');
    if (!sel || !sel.form) return;
    var form = sel.form;
    var dataEl = form.querySelector('[data-variant-inventory]');
    var btn = form.querySelector('[data-add-to-cart]');
    if (!dataEl || !btn) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (_) { return; }
    var v = variants.filter(function (x) { return String(x.id) === String(sel.value); })[0];
    if (!v) return;
    var label = btn.getAttribute('data-label') || 'Add to cart';
    if (v.available) {
      btn.textContent = label + ' · ' + v.priceText;
      btn.removeAttribute('disabled');
    } else {
      btn.textContent = btn.getAttribute('data-sold-out') || 'Sold out';
    }
  });

  document.addEventListener('DOMContentLoaded', function () { refresh(); });
  window.ImperialTheme = { refresh: refresh, openDrawer: openDrawer, addItem: addItem };
})();
